import { useState } from 'react'
import type { FC } from 'react'
import { useQuery } from '@tanstack/react-query'

import { rqKeys } from '@/react-query-keys'
import { apiRequestNew } from '@/helpers/request'
import { getMs } from '@/helpers'
import { formatTs } from '@/helpers'
import { Drawer, Skeleton } from '@/components'
import type { T_NewsListRes } from '@/types/responses'
import { NewsArticleDrawer } from '../news-article-drawer'
import {
  SC_NewsListWrapper,
  SC_NewsItem,
  SC_NewsDate,
  SC_NewsTitle,
} from './styled'


interface T_NewsDrawerProps {
  hideNewsDrawer: () => void
}

export const NewsDrawer: FC<T_NewsDrawerProps> = ({
  hideNewsDrawer,
}) => {
  const [ selectedArticle, setSelectedArticle ] = useState<string | null>(null)

  const {
    data: newsList,
    isPending: isNewsListPending,
  } = useQuery<T_NewsListRes>({
    queryKey: [ rqKeys.newsList, 'all' ],
    queryFn: () => apiRequestNew(
      'GET',
      '/portal/article?lang=47&path=information%2Fnews&visitor_group=1%2C2&order=timed&offset=0&limit=9999'
    ),
    staleTime: getMs('15m'),
    refetchOnWindowFocus: false,
  })


  return (
    <Drawer
      backTitle='Все новости'
      onClose={hideNewsDrawer}
      isBackdropClosable
      isFullScreen
    >
      <div>
        {isNewsListPending ? (
          <Skeleton count={3} />
        ) : (
          <SC_NewsListWrapper hasPaddings>
            {(newsList || []).map((item) => (
              <SC_NewsItem key={item.id} onClick={() => setSelectedArticle(item.name)}>
                <SC_NewsDate>{formatTs(item.time)}</SC_NewsDate>
                <SC_NewsTitle>{item.title.ru}</SC_NewsTitle>
              </SC_NewsItem>
            ))}
          </SC_NewsListWrapper>
        )}
      </div>

      {selectedArticle && (
        <NewsArticleDrawer
          articleName={selectedArticle}
          onClose={() => setSelectedArticle(null)}
        />
      )}
    </Drawer>
  )
}
